import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [content, setContent] = useState({});
  const [assets, setAssets] = useState({});
  const [loading, setLoading] = useState(true);

  const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
  const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || (isProduction 
    ? 'https://eunikareinternational.org' 
    : 'http://127.0.0.1:5000');
  const API_URL = process.env.REACT_APP_API_URL || `${BACKEND_BASE_URL}/api`;

  const fetchAll = async () => {
    try {
      const [settingsRes, contentRes, assetsRes] = await Promise.all([
        fetch(`${API_URL}/settings`).then(res => res.json()),
        fetch(`${API_URL}/content`).then(res => res.json()),
        fetch(`${API_URL}/assets`).then(res => res.json())
      ]);

      setSettings(settingsRes);
      setContent(contentRes);
      setAssets(assetsRes);

      // Apply CSS variables to root
      if (settingsRes) {
        Object.entries(settingsRes).forEach(([key, value]) => {
          if (value) {
            document.documentElement.style.setProperty(`--${key}`, value);
          }
        });
      }
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const value = {
    settings,
    content,
    assets,
    loading,
    refresh: fetchAll
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
